import { Card } from 'antd';
import React, { useContext } from 'react';
import { AppContext } from '../../../AppContext';
import { MODULES } from '../../../common/constants';
import Portal from '../../../components/Portal';
import DynamicFieldsTable from '../components/DynamicFieldsTable';

const DynamicFieldsList = ({ setSelectedDynamicKey, selectedDynamicKey }) => {
  const {
    state: { pageSize }
  } = useContext(AppContext);
  return (
    <Card className="full-height-card card-body-padding">
      <Portal portalId="header-left-content">
        <span className="portal-header">{MODULES?.DYNAMIC_FIELDS}</span>
      </Portal>
      {pageSize && (
        <DynamicFieldsTable
          setSelectedDynamicKey={setSelectedDynamicKey}
          selectedDynamicKey={selectedDynamicKey}
        />
      )}
    </Card>
  );
};

export default DynamicFieldsList;
